"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logError = exports.pageView = exports.configureLogging = exports.getDatadogLogger = exports.configureDatadog = void 0;
const realUserMonitoring_1 = require("./realUserMonitoring");
const logging_1 = require("./logging");
const realUserMonitoring_2 = require("./realUserMonitoring");
const configureDatadog = ({ appId, appName, appVersion, clientPublicToken, configureLogging = false, forwardConsoleLogs = "all", environment, trackViewsManually = false, }) => {
    (0, realUserMonitoring_2.configure)({
        appId,
        appName,
        appVersion,
        clientPublicToken,
        environment,
        trackViewsManually,
    });
    if (configureLogging) {
        (0, logging_1.configure)({
            appName,
            appVersion,
            clientPublicToken,
            environment,
            forwardConsoleLogs,
        });
    }
};
exports.configureDatadog = configureDatadog;
var logging_2 = require("./logging");
Object.defineProperty(exports, "getDatadogLogger", { enumerable: true, get: function () { return logging_2.getDatadogLogger; } });
var logging_3 = require("./logging");
Object.defineProperty(exports, "configureLogging", { enumerable: true, get: function () { return logging_3.configure; } });
const pageView = ({ name: viewName }) => {
    (0, realUserMonitoring_1.startView)({ name: viewName });
};
exports.pageView = pageView;
const logError = (error, context) => {
    (0, realUserMonitoring_1.addError)(error, context);
};
exports.logError = logError;
//# sourceMappingURL=index.js.map